import { createApiMutation, createApiQuery } from '@/features/api'

import type {
	ICategory,
	ICategoryMutationPayload,
	IProduct,
	IProductMutationPayload,
} from './type'

/* ----------------------------- PRODUCT MASTER ----------------------------- */

export const productList = createApiQuery<{
	params: { outletId: string }
	result: { products: Array<IProduct> }
}>('/product/list')

export const productDetail = createApiQuery<{
	params: { id: string }
	result: { product: IProduct }
}>('/product/detail')

export const productCreate = createApiMutation<{
	params: { outletId: string }
	body: IProductMutationPayload
}>('/product/create', { method: 'post' })

export const productUpdate = createApiMutation<{
	params: { id: string }
	body: IProductMutationPayload & { id: string }
}>('/product/update', { method: 'put' })

/* -------------------------------- CATEGORY -------------------------------- */

export const productCategoryList = createApiQuery<{
	params: { outletId: string }
	result: { categories: Array<ICategory> }
}>('/product/category/list')

export const productCategoryDetail = createApiQuery<{
	params: { id: string }
	result: { category: ICategory }
}>('/product/category/detail')

export const productCategoryCreate = createApiMutation<{
	params: { outletId: string }
	body: ICategoryMutationPayload
}>('/product/category/create', { method: 'post' })

export const productCategoryUpdate = createApiMutation<{
	params: { id: string }
	body: ICategoryMutationPayload & { id: string }
}>('/product/category/update', { method: 'put' })
